import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, DashboardModule, ListItem, LoadingModule, Text,
} from '@campaignhub/suit-theme'

import BlockoutItem from './components/BlockoutItem'
import DateRangeFilter from './components/DateRangeFilter'

const Blockouts = (props) => {
  const {
    blockouts, callbacks, dateStart, dateEnd, hasMore, loading,
  } = props

  return (
    <Box flexDirection="column">
      <DateRangeFilter
        dateStart={dateStart}
        dateEnd={dateEnd}
        callbacks={{ setDateRange: callbacks.setDateRange }}
      />
      <Box flexDirection="column">
        <ListItem
          boxProps={{
            borderBottom: '1px solid',
            padding: 'large',
          }}
          flexDirection="column"
          disableHover
        >
          <Text fontSize="xsmall" color="bodyFontLightColor">
            Note: You will still need to attend appointments that have already been confirmed.
          </Text>
        </ListItem>
        {blockouts.sort((a, b) => Date.parse(b.start) - Date.parse(a.start)).map(blockout => (
          <BlockoutItem key={blockout.id} blockout={blockout} />
        ))}
        <LoadingModule loading={loading} boxProps={{ border: 0 }} />
      </Box>
      {blockouts.length === 0 && !loading && (
        <ListItem
          boxProps={{
            borderBottom: '1px solid',
            padding: 'large',
          }}
          flexDirection="column"
          disableHover
        >
          <Text fontSize="xsmall" color="bodyFontLightColor">
            No Blocked Dates On Selected Date Range
          </Text>
        </ListItem>
      )}
      {blockouts.length > 0 && (
        <DashboardModule.LoadMoreFooter
          callbacks={{ loadMore: callbacks.loadMore }}
          canLoadMore={hasMore}
          entityCount={blockouts.length}
        />
      )}
    </Box>
  )
}

Blockouts.propTypes = {
  blockouts: PropTypes.array.isRequired,
  callbacks: PropTypes.shape({
    loadMore: PropTypes.func.isRequired,
    setDateRange: PropTypes.func.isRequired,
  }).isRequired,
  dateStart: PropTypes.instanceOf(Date).isRequired,
  dateEnd: PropTypes.instanceOf(Date).isRequired,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
}

export default Blockouts
